import { apiClient } from "@/api/apiClient";
import merge from "lodash.merge";
import type { AxiosRequestConfig } from "axios";

export const fetchDocumentsAsync = (options?: AxiosRequestConfig) => {
  const defaultOptions: AxiosRequestConfig = {
    params: {
      sort: `["createdAt","DESC"]`,
      range: "[0, 999]",
    },
  };
  return apiClient().get("documents", merge(defaultOptions, options));
};

export const fetchDocumentCategoriesAsync = (options?: AxiosRequestConfig) => {
  const defaultOptions: AxiosRequestConfig = {
    params: {
      sort: `["createdAt","DESC"]`,
    },
  };
  return apiClient().get(
    "documents/_categories",
    merge(defaultOptions, options),
  );
};
